import UseStage41Header from "./Header";
import "./index.css";
import MaterialsEnergyWater41_1a from "./MaterialsEnergyWater41_1a";
import SurplusResources41_1b from "./SurplusResources41_1b";
import DirectEmissions41_1c from "./DirectEmissions41_1c";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdUseStage41Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="prod-use-stage-41-container" id="prod-use-stage-41-id">
      <UseStage41Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <MaterialsEnergyWater41_1a productId={productId} />
          <SurplusResources41_1b productId={productId} />
          <DirectEmissions41_1c productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdUseStage41Components;


